import { render, staticRenderFns } from "./InfoBoxPanel.vue?vue&type=template&id=8a52190c&scoped=true"
import script from "./InfoBoxPanel.vue?vue&type=script&lang=js"
export * from "./InfoBoxPanel.vue?vue&type=script&lang=js"
import style0 from "./InfoBoxPanel.vue?vue&type=style&index=0&id=8a52190c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a52190c",
  null
  
)

export default component.exports